import { render } from "./notify-setting.vue?vue&type=template&id=5e621b9b&scoped=true&ts=true"
import script from "./notify-setting.vue?vue&type=script&lang=ts"
export * from "./notify-setting.vue?vue&type=script&lang=ts"

import "./notify-setting.vue?vue&type=style&index=0&id=5e621b9b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e621b9b"]])

export default __exports__